import React from 'react';
import SystemMsgModalContainer from './SystemMsgModalContainer'

class SystemModalContainer extends React.Component {
    render() {
        return (
            <div>
                <SystemMsgModalContainer/>
            </div>
        )
    }

}
export default SystemModalContainer



// WEBPACK FOOTER //
// ./src/dashboards_redux/containers/DefaultModalTemplatContainer/SystemModalContainer.jsx